import { BsFillExclamationCircleFill } from "react-icons/bs";
import { Modal } from "reactstrap";
import { Field, Form } from "react-final-form";
import OutlinedFormInput from "../../../../Finance/components/OutlinedFormInput/OutlinedFormInput";
import MeritoButton from "../../../../../components/common/MeritoButtons/MeritoButtons";
import styles from "./DeleteConfirmation.module.scss";
import { formActionTypes, SalesMarketingSectionTypes } from "../../../../../interfaces/interfaces";
import { useState } from "react";
import { RiCheckboxCircleFill } from "react-icons/ri";


type Props = {
  initialValues: any;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  handleChange?: Function;
  sectionType: SalesMarketingSectionTypes;
  closeChannelPopup: () => void;
};

const DeleteConfirmation = ({ initialValues, isOpen, setIsOpen, handleChange, sectionType, closeChannelPopup }: Props) => {
  const [step, setStep] = useState(1);
  const submitForm = (values: any) => {
    const obj = {
      ...initialValues,
      deleteReason: values.deleteReason,
      isDeleted: true
    }
    handleChange(obj, sectionType, formActionTypes.edit)
    setStep(2);
  }

  return (
    <Modal isOpen={isOpen} size='md' centered={true} className={styles.deleteConfirmationModal} contentClassName={styles.deleteConfirmationContent}>
      {
        step == 1 ?
          <>
            <BsFillExclamationCircleFill className={styles.redSvg} />
            <h2>Delete {initialValues?.label}?</h2>
            <Form
              initialValues={{ deleteReason: '' }}
              validate={(values) => {
                return {}
              }}
              onSubmit={(values) => {
                submitForm(values);
              }} render={({ values, handleSubmit, pristine, hasValidationErrors, form: { change, batch, mutators } }) => {
                return (
                  <form onSubmit={handleSubmit} className={styles.deleteReasonForm}>
                    <div className={styles.formBodyContainer}>
                      <Field
                        name="deleteReason"
                        validate={(value) => {
                          if (!value) {
                            return `Enter the reason`
                          }
                        }}
                      >
                        {(props) => (
                          <OutlinedFormInput
                            {...props.input}
                            label="Reason for deleting"
                            name="deleteReason"
                            value={props.input.value}
                            onChange={props.input.onChange}
                            placeholder="Added by mistake, not using this channel, no data available"
                            error={props.meta.error}
                            touched={props.meta.touched}
                            maxLength={200}
                          />

                        )}
                      </Field>
                      <p>This will be added to your investor report</p>
                    </div>
                    <div className={styles.footerContainer}>
                      <MeritoButton btnText="Cancel" isRounded={true} type="secondary-2" onClick={() => setIsOpen(false)} />
                      <MeritoButton disabled={pristine || hasValidationErrors} btnText={"Delete"} isRounded={true} type="primary-1" onClick={() => {
                        handleSubmit();
                      }} />
                    </div>
                  </form>
                )
              }} />
          </> :
          <>
            <RiCheckboxCircleFill className={styles.greenSvg} />
            <h2>Channel Deleted Successfully!</h2>
            <div className={styles.footerContainer}>
              <MeritoButton btnText="Close" isRounded={true} type="secondary-2" onClick={() => {
                setIsOpen(false);
                setStep(1);
                closeChannelPopup();
              }} />
            </div>
          </>
      }
    </Modal>
  )
}

export default DeleteConfirmation;